import { render, staticRenderFns } from "./SitesStatistics.vue?vue&type=template&id=70dcffd3&scoped=true&"
import script from "./SitesStatistics.vue?vue&type=script&lang=js&"
export * from "./SitesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SitesStatistics.vue?vue&type=style&index=0&id=70dcffd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcffd3",
  null
  
)

export default component.exports